"use strict";
var PairsObservable_1 = require('./PairsObservable');
exports.pairs = PairsObservable_1.PairsObservable.create;
//# sourceMappingURL=pairs.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/rxjs/observable/pairs.js
// module id = rAcl
// module chunks = 6